import React from 'react';
import { navigateToPath } from '../utils/navigation';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href?: string) => {
    if (href) {
      e.preventDefault();
      navigateToPath(href);
    }
  };

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center space-x-2 text-sm">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && (
                <li className="flex items-center text-gray-400" aria-hidden="true">
                    <svg className="h-5 w-5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                </li>
            )}
            <li>
                {item.href ? (
                <a
                    href={item.href}
                    onClick={(e) => handleClick(e, item.href)}
                    className="font-medium text-brand-purple hover:underline"
                >
                    {item.label}
                </a>
                ) : (
                <span className="font-medium text-gray-500" aria-current="page">
                    {item.label}
                </span>
                )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
